/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
      constructor() {
        super();
        const id = this.dataset.section;
        this.button = this.querySelector('.load-more');
        this.grid = document.querySelector('[data-id=' + id + ']');
        this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
        this.i = 2;
        this.totalPages = parseInt(this.dataset.totalPages) || 0;
        this._done = false;
      }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio > 0 && !base._done) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    _finish() {
      this._done = true;
      if (this.observer) {
        this.observer.unobserve(this);
        this.observer.disconnect();
      }
      if (this.button) this.button.classList.add('visually-hidden');
      this.style.display = 'none';
    }
    loadProducts() {
      let base = this;
      if (base.getAttribute('loading') || base._done) {
        return;
      }
      if (base.totalPages > 0 && base.i > base.totalPages) {
        base._finish();
        return;
      }
      let url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.i++;
          base.renderProducts(html, url);
          if (base.totalPages > 0 && base.i > base.totalPages) {
            base._finish();
          }
          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        })
        .catch(() => {
          base.removeAttribute('loading');
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        base._finish();
        base.removeAttribute('loading');
        return;
      }

      // Collect IDs already in the current grid to prevent duplicates
      let existingIds = new Set();
      base.grid.querySelectorAll('.column[data-product-id]').forEach(el => {
        existingIds.add(el.dataset.productId);
      });

      let products = Array.from(grid_to_replace.querySelectorAll('.column'));

      // Filter out any product that is already rendered (dedup guard)
      let newProducts = products.filter(el => {
        let pid = el.dataset.productId;
        if (!pid) return true; // no id attr — always add
        if (existingIds.has(pid)) return false;
        existingIds.add(pid);
        return true;
      });

      if (newProducts.length === 0) {
        base._finish();
        base.removeAttribute('loading');
        return;
      }

      for (var i = 0; i < newProducts.length; i++) {
        base.grid.appendChild(newProducts[i]);
        newProducts[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }
      if (base.animations_enabled) {
        gsap.set(newProducts, {
          opacity: 0,
          y: 30
        });
        gsap.to(newProducts, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
